/**
 * Created by m.igrachev on 6/19/2017.
 */
const documentedProperties = [
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Extra css classes to be added to Preloader container."
    },
    {
        name: "small",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true reduce preloader size."
    },
    {
        name: "fadeAnimation",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true add fade in-out animation effect."
    },
    {
        name: "customContent",
        type: "element",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Markup of the spinner can be defined through this property."
    },
    {
        name: "status",
        type: "[show, waitContentRender, fadein, fadeout, hide, wait]",
        defaultValue: "show",
        isRequired: "false",
        description: "Preloader status."
    },
    {
        name: "minHeight",
        type: "Number",
        defaultValue: "n/a",
        isRequired: "false",
        description: "The minimum height of the element."
    },
    {
        name: "label",
        type: "String",
        defaultValue: "false",
        isRequired: "false",
        description: "In case of preloaderType=label - the loading animation label."
    }
];

export default documentedProperties;
